import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlannerService {

  constructor(
    private http: HttpClient
  ) { }

  index() {
    return this.http.get('planners/index');
  }

}
